import PT from 'prop-types';
import React from 'react';

import Box from '~/ui/components/Box/Box';
import Card from '~/ui/components/Card/index';
import FlexLayout from '~/ui/components/FlexLayout/FlexLayout';
import Text from '~/ui/components/Text/Text';

function IntegrationDetailCard({
  headerRightContent,
  logoSrc,
  title,
  ...rest
}) {
  const header = (
    <Card.Header
      rightContent={headerRightContent}
      title={
        <FlexLayout alignItems="center" ml={3} space={6}>
          <Box
            as="img"
            src={logoSrc}
            sx={{
              height: 'auto',
              width: 40,
            }}
          />
          <Text variant="s-dense-bold">{title}</Text>
        </FlexLayout>
      }
    />
  );

  return <Card header={header} {...rest} />;
}

IntegrationDetailCard.propTypes = {
  headerRightContent: PT.node,
  logoSrc: PT.string.isRequired,
  title: PT.string.isRequired,
};

export default IntegrationDetailCard;
